import { atomWithReset } from "jotai/utils";

import type { ClaimOrderListItem } from "../dtos/get-claim-order-list-response-dto";

export type ClaimOrderSubmitPrefill = {
  invoiceNumber: string;
  invoiceAmount: number;
  invoiceDate?: string;
  taxInvoiceNumber?: string;
  bankName: string;
  accountNumber: string;
  accountName: string;
  invoiceFilePath?: string;
  rejectReason?: string;
};

export const claimOrderSubmitModalAtom = atomWithReset<{
  publicId?: string;
  currentStatus?: string;
  visible: boolean;
  data: { orders: ClaimOrderListItem[] } | null;
  prefill?: ClaimOrderSubmitPrefill;
}>({
  visible: false,
  data: null
});
